//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 07/10/2025
// Version       : 1
// Description   : Agregar tipos de vehículos
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import {
  TextField,
  Stack,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Grid from "@mui/material/Grid";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AgregarTipo(props) {
  const [datosTipo, setDatosTipo] = useState({
    nombre: null,
    estado: 1,
    requiere_chofer: 0,
    es_t1: 0,
    es_grua: 0,
  });

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [severity, setSeverity] = useState("success"); // "success" | "error"

  //*************************************************************************************************************************************/

  // DESHABILITAR BOTON AL GUARDAR
  const [disBtn, setDisBtn] = useState(false);

  //*************************************************************************************************************************************/

  // Función que normaliza texto para comparar nombres
  const normalizarTexto = (texto) => {
    return texto
      ? texto
          .normalize("NFD") // separo letras y acentos
          .replace(/[\u0300-\u036f]/g, "") // elimino acentos
          .trim()
          .toLowerCase()
      : "";
  };

  // --- Verificar si ya existe un "tipo" con ese nombre ---
  const nombreExiste = async (nombre) => {
    if (!nombre) return false;
    const nombreNormalizado = normalizarTexto(nombre);

    try {
      const res = await fetch(`${UrlApi}/tipos_vehiculos2`);
      if (!res.ok) return false;
      const data = await res.json();

      // Comparo los nombres normalizados
      if (Array.isArray(data)) {
        return data.some(
          (item) => normalizarTexto(item.nombre) === nombreNormalizado
        );
      }

      // Si devuelve un objeto con propiedad exists (por ej. {exists:true})
      if (typeof data === "object" && "exists" in data) {
        return !!data.exists;
      }

      return false;
    } catch (err) {
      return false;
    }
  };

  //*************************************************************************************************************************************/

  // Función GUARDAR
  const guardarCrear = async (e) => {
    e.preventDefault();

    // Nombre no vacío
    const nombreTrim = (datosTipo.nombre || "").toString().trim();
    if (!nombreTrim) {
      setSeverity("error");
      setColorMensaje("#F1948A");
      setMensaje("El nombre no puede quedar vacío.");
      setOpenSnack(true);
      return;
    }

    // Verifica existencia antes de intentar POST
    const existe = await nombreExiste(nombreTrim);
    if (existe) {
      setSeverity("error");
      setColorMensaje("#F1948A");
      setMensaje("Ya existe un tipo de vehículo con ese nombre.");
      setOpenSnack(true);
      setDisBtn(false);
      return;
    }

    try {
      const res = await fetch(UrlApi + "/tipos_vehiculos2", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nombre: nombreTrim,
          estado: 1, // "Tipos" activos por defecto
          requiere_chofer: datosTipo.requiere_chofer,
          es_t1: datosTipo.es_t1,
          es_grua: datosTipo.es_grua,
        }),
      });
      const data = await res.json();

      if (res.ok) {
        setSeverity("success");
        setColorMensaje("#D4EFDF");
        setMensaje("El tipo se guardó exitosamente!");
      } else if (res.status === 409) {
        // Nombre duplicado
        setSeverity("error");
        setColorMensaje("#F1948A");
        setMensaje(data.message || "El tipo ya existe.");
        setDisBtn(false);
      } else {
        // Otro error
        setSeverity("error");
        setColorMensaje("#F1948A");
        setMensaje(data.error || "Error al guardar el tipo.");
        setDisBtn(false);
      }
    } catch (err) {
      setSeverity("error");
      setColorMensaje("#F1948A");
      setMensaje("Error de red o servidor.");
      setDisBtn(false);
    } finally {
      setOpenSnack(true);
    }
  };

  const almacenar = (e) => {
    const { name, value } = e.target;
    setDatosTipo((prev) => ({
      ...prev,
      [name]: name === "nombre" ? value : value === "" ? null : value,
    }));
  };

  //*************************************************************************************************************************************/

  // Checkboxes
  const handleCheckboxChange = (e) => {
    // Extrae nombre del checkbox y su estado
    const { name, checked } = e.target;

    // Actualizo
    setDatosTipo((prev) => ({
      ...prev, // Valores actuales sin modificar
      [name]: checked ? 1 : 0, // Se asigna 1 si está check, 0 si no lo está
    }));
  };

  //*************************************************************************************************************************************/

  // Cierre de la notificación
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnack(false);

    if (severity === "success") {
      // Refrescar datos y cerrar diálogo
      props.onTipoGuardado();
      props.handleCloseAgregarTipo();
      setDisBtn(false);
      // limpiar formulario
      // setDatosTipo({
      //   nombre: "",
      //   estado: 1,
      //   requiere_chofer: 0,
      //   es_t1: 0,
      //   es_grua: 0
      // });
    }
    // Si fue error, no se cierra el diálogo, solo se reactiva el botón
  };

  return (
    <>
      <Box>
        <DialogTitle
          sx={{
            p: 0,
            mt: 0,
            mb: 3,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="h6"
            color="white"
            sx={{
              background: "linear-gradient(135deg, #2B76A6 0%, #094d77ff 100%)",
              borderBottomRightRadius: "12px",
              padding: "8px 18px",
            }}
          >
            Agregar Tipo de Vehículo
          </Typography>
        </DialogTitle>

        <DialogContent>
          <form onSubmit={guardarCrear}>
            <Grid container spacing={2} mt={0.5}>
              <Grid item xs={12}>
                <TextField
                  label="Nombre"
                  required
                  focused
                  size="small"
                  name="nombre"
                  autoComplete="off"
                  fullWidth
                  value={datosTipo.nombre}
                  onChange={almacenar}
                  sx={{
                    "& .MuiInputBase-root": {
                      minHeight: 40,
                    },
                  }}
                />
              </Grid>

              {/* CHECKBOXES */}
              <Grid item xs={12}>
                <Box
                  sx={{
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.95), rgba(250,250,252,0.95))",
                    border: "1px solid rgba(25,118,210,0.12)",
                    borderRadius: 2,
                    p: 2,
                    boxShadow: "0 6px 18px rgba(15, 40, 60, 0.03)",
                  }}
                >
                  <Grid container spacing={2} alignItems="center">
                    {/* Título */}
                    <Grid item xs={12} md={2}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: "#0f4c81",
                          mb: { xs: 1, md: 0 },
                        }}
                      >
                        Opciones
                      </Typography>
                    </Grid>

                    {/* Checkboxes */}
                    <Grid item xs={12} md={10}>
                      <Grid container spacing={1} alignItems="center">
                        {/* Requiere Chofer */}
                        <Grid item xs={6} sm={4} md={2.5}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={datosTipo.requiere_chofer === 1}
                                onChange={handleCheckboxChange}
                                name="requiere_chofer"
                                size="small"
                                sx={{
                                  transform: "scale(1.15)",
                                  "& .MuiSvgIcon-root": { fontSize: 20 },
                                }}
                              />
                            }
                            label={
                              <Typography sx={{ fontWeight: 600 }}>
                                Requiere Chofer
                              </Typography>
                            }
                            labelPlacement="end"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          />
                        </Grid>

                        {/* Es T1 */}
                        <Grid item xs={6} sm={4} md={2.5}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={datosTipo.es_t1 === 1}
                                onChange={handleCheckboxChange}
                                name="es_t1"
                                size="small"
                                sx={{
                                  transform: "scale(1.15)",
                                  "& .MuiSvgIcon-root": { fontSize: 20 },
                                }}
                              />
                            }
                            label={
                              <Typography sx={{ fontWeight: 600 }}>
                                Es T1
                              </Typography>
                            }
                            labelPlacement="end"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          />
                        </Grid>

                        {/* Es Grúa */}
                        <Grid item xs={6} sm={4} md={2.5}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={datosTipo.es_grua === 1}
                                onChange={handleCheckboxChange}
                                name="es_grua"
                                size="small"
                                sx={{
                                  transform: "scale(1.15)",
                                  "& .MuiSvgIcon-root": { fontSize: 20 },
                                }}
                              />
                            }
                            label={
                              <Typography sx={{ fontWeight: 600 }}>
                                Es Grúa
                              </Typography>
                            }
                            labelPlacement="end"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* BOTONES EN LÍNEA */}
              <Grid item xs={12} mt={3}>
                <Box display="flex" justifyContent="space-between">
                  <Button
                    variant="contained"
                    color="error"
                    onClick={props.handleCloseAgregarTipo}
                    sx={{
                      borderRadius: "12px",
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Volver
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={disBtn}
                    sx={{
                      borderRadius: "12px",
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Guardar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Box>

      {/* Notificación al Guardar */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={severity}
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default AgregarTipo;
